import { __rest } from "tslib";
export const inputPropsForSmuiTextfield = (_a) => {
    var { name } = _a, input = __rest(_a, ["name"]);
    return Object.assign({ input$name: name, 'input$aria-controls': `helper-text-${name}`, 'input$aria-describedby': `helper-text-${name}` }, input);
};
export const inputPropsForSmuiRadio = (_a) => {
    var _b = _a.input, { name, value: staticValue, checked } = _b, input = __rest(_b, ["name", "value", "checked"]), { state: { value } } = _a;
    // The current version of svelte-material-ui doesn't let you set `checked` directly; you have to set it indirectly via a `group` prop.
    // By contrast, in [the rewrite](https://github.com/svelte-material-ui-test/core/blob/master/packages/radio/src/Radio.svelte), the `checked` prop _will_ be used and no `group` prop provided.
    return Object.assign({ input$name: name, group: value, value: staticValue }, input);
};
export const inputPropsForSmuiCheckbox = (_a) => {
    var { name } = _a, input = __rest(_a, ["name"]);
    return Object.assign({ input$name: name }, input);
};
